import React, { Component } from "react";
import Navbar from "../navbar/navbar";
import "./committee.css";
import "../home/home.css";
import chiefPatron from "./chiefPatron.json";
import patron from "./Patron.json";
import general from "./general.json";
import advisory from "./advisory.json";
import organising from "./organising.json";
import technical from "./technical.json";
import guest from "./guestEditor.json";
import technicalChair from "./technicalChair.json";
import localEditor from "./localEditor.json";
import programChair from "./programChairs.json";
import publicationChair from "./PublicationChairs.json";
import industrialChair from "./industrialChair.json";
class Committee extends Component {
	render() {
		return (
			<>
				<div className="header-area">
					<div id="home" className="contact-header-area  bg_cover">
						<Navbar />
						<div className=" d-flex align-items-center">
							<div className="container">
								<div className="row justify-content-center">
									<div className="col-lg-10">
										<div className="header-content text-center">
											<h2 className="header-title2">COMMITTEE</h2>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="schedule-section row" style={{ margin: 0 }}>
					<table className="annoucement-table container">
						<tr className="annoucement-table-header-row">
							<th className="committee-th">CHIEF PATRON</th>
							<th></th>
						</tr>
						{chiefPatron &&
							chiefPatron.map((a, key) => (
								<tr className="announcement-table-row">
									<td className="annoucement-title">{a?.name}</td>
									<td>{a?.pos}</td>
								</tr>
							))}
					</table>

					<table className="annoucement-table container">
						<tr className="annoucement-table-header-row">
							<th className="committee-th">PATRONS</th>
							<th></th>
						</tr>
						{patron &&
							patron.map((a, key) => (
								<tr className="announcement-table-row">
									<td className="annoucement-title">{a?.name}</td>
									<td>{a?.pos}</td>
								</tr>
							))}
					</table>

					<table className="annoucement-table container">
						<tr className="annoucement-table-header-row">
							<th className="committee-th">GENERAL CHAIR </th>
							<th></th>
						</tr>
						{general &&
							general.map((a, key) => (
								<tr className="announcement-table-row">
									<td className="annoucement-title">{a?.name}</td>
									<td>{a?.pos}</td>
								</tr>
							))}
					</table>
					<table className="annoucement-table container">
						<tr className="annoucement-table-header-row">
							<th className="committee-th">PROGRAM CHAIR </th>
							<th></th>
						</tr>
						{programChair &&
							programChair.map((a, key) => (
								<tr className="announcement-table-row">
									<td className="annoucement-title">{a?.name}</td>
									<td>{a?.pos}</td>
								</tr>
							))}
					</table>

					<table className="annoucement-table container">
						<tr className="annoucement-table-header-row">
							<th className="committee-th">PUBLICATION CHAIR </th>
							<th></th>
						</tr>
						{publicationChair &&
							publicationChair.map((a, key) => (
								<tr className="announcement-table-row">
									<td className="annoucement-title">{a?.name}</td>
									<td>{a?.pos}</td>
								</tr>
							))}
					</table>

					<table className="annoucement-table container">
						<tr className="annoucement-table-header-row">
							<th className="committee-th">TECHNICAL CHAIR </th>
							<th></th>
						</tr>
						{technicalChair &&
							technicalChair.map((a, key) => (
								<tr className="announcement-table-row">
									<td className="annoucement-title">{a?.name}</td>
									<td>{a?.pos}</td>
								</tr>
							))}
					</table>
					<table className="annoucement-table container">
						<tr className="annoucement-table-header-row">
							<th className="committee-th">INDUSTRIAL CHAIR </th>
							<th></th>
						</tr>
						{industrialChair &&
							industrialChair.map((a, key) => (
								<tr className="announcement-table-row">
									<td className="annoucement-title">{a?.name}</td>
									<td>{a?.pos}</td>
								</tr>
							))}
					</table>

					{/* <table className="annoucement-table container">
            <tr className="annoucement-table-header-row">
              <th className="committee-th">GUEST EDITOR</th>
              <th></th>
            </tr>
            {guest &&
              guest.map((a, key) => (
                <tr className="announcement-table-row">
                  <td className="annoucement-title">{a?.name}</td>
                  <td>{a?.pos}</td>
                </tr>
              ))}
          </table>

          <table className="annoucement-table container">
            <tr className="annoucement-table-header-row">
              <th className="committee-th">LOCAL EDITORS</th>
              <th></th>
            </tr>
            {localEditor &&
              localEditor.map((a, key) => (
                <tr className="announcement-table-row">
                  <td className="annoucement-title">{a?.name}</td>
                  <td>{a?.pos}</td>
                </tr>
              ))}
          </table>
 */}

					{/* <table className="annoucement-table container">
            <tr className="annoucement-table-header-row">
              <th className="committee-th">CONFERENCE CHAIRS </th>
              <th></th>
            </tr>
            {conf &&
              conf.map((a, key) => (
                <tr className="announcement-table-row">
                  <td className="annoucement-title">{a?.name}</td>
                  <td>{a?.pos}</td>
                </tr>
              ))}
          </table> */}
					<table className="annoucement-table container">
						<tr className="annoucement-table-header-row">
							<th className="committee-th">ADVISORY COMMITTEE </th>
							<th></th>
						</tr>
						{advisory &&
							advisory.map((a, key) => (
								<tr className="announcement-table-row">
									<td className="annoucement-title">{a?.name}</td>
									<td>{a?.pos}</td>
								</tr>
							))}
					</table>
					<table className="annoucement-table container">
						<tr className="annoucement-table-header-row">
							<th className="committee-th">TECHNICAL COMMITTEE </th>
							<th></th>
						</tr>
						{technical &&
							technical.map((a, key) => (
								<tr className="announcement-table-row">
									<td className="annoucement-title">{a?.name}</td>
									<td>{a?.pos}</td>
								</tr>
							))}
					</table>
					<table className="annoucement-table container">
						<tr className="annoucement-table-header-row">
							<th className="committee-th">ORGANISING COMMITTEE </th>
							<th></th>
						</tr>
						{organising &&
							organising.map((a, key) => (
								<tr className="announcement-table-row">
									<td className="annoucement-title">{a?.name}</td>
									<td>{a?.pos}</td>
								</tr>
							))}
					</table>
				</div>
			</>
		);
	}
}

export default Committee;
